import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import 'styles/nav.scss';

const homePath = '/';
const aboutPath = '/about';
const galleryPath = '/gallery';
const paymentPath = "/pay";

const homeTitle = 'Home';
const aboutTitle = 'About Me';
const galleryTitle = 'Gallery';
const paymentTitle = 'Pay For Services';

const paths = [
    [homePath, homeTitle],
    [aboutPath, aboutTitle],
    [galleryPath, galleryTitle],
    [paymentPath, paymentTitle],
];

class Nav extends Component {
    render() {
        return (
            <div className='nav-container'>
                <div className='title'>April Brust Studios</div>
                <div className='nav-links'>
                    <ul>
                        {paths.map(keyVal =>
                            <li className="nav-item" key={keyVal[0]}>
                                <Link className="nav-link" to={keyVal[0]}>{keyVal[1]}</Link>
                            </li>
                        )}
                        <li className='nav-item' key='resume'>
                            <Link className='nav-link' to='/resume'>Resume</Link>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}
export default Nav;


// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js